import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';
import { Factory, FactoryService } from '@app/core/factories';
import { StaffService } from '@app/core/staff';

@Component({
  selector: 'cnc-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss'],
})
export class AuthFormModalComponent implements OnInit {
  hide :boolean = true;
  loading :boolean = false;
  submitted :boolean = false;
  pageTitle :string = this.translate.instant('TITLES.NEW_SUPPLIER');
  formData :UntypedFormGroup;
  factoryAdmins :any = [];

  @Input() factory :Factory;

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    private factoryService :FactoryService,
    public staffService :StaffService,
    private toastr :ToastrService,
    private translate :TranslateService,
    public authService :AuthService,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      factory_name: ['', Validators.required],
      factory_admin_id: ['', Validators.required],
      factory_description: ['', Validators.required],
      street_address: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      country: ['', Validators.required],
      bank_name: ['', Validators.required],
      routing_number: ['', Validators.required],
      account_number: ['', Validators.required],
      swift_code: [''],
      contact_name: ['', Validators.required],
      contact_email: ['', [Validators.required, Validators.email]],
      contact_phone: ['', Validators.required],
    });

    if (this.factory) {
      this.pageTitle = this.translate.instant('TITLES.EDIT_SUPPLIER');
      this.formData.patchValue(this.factory);
    } else {
      if (this.authService.loginUser.role == 8) {
        this.formData.patchValue({
          factory_admin_id: this.authService.loginUser.id,
        });
      }
    }

    this.staffService.staff$.subscribe((staff :any) => {
      this.factoryAdmins = staff.filter((row) => row.role == 8);
      if (this.authService.loginUser.role >= 8) {
        this.factoryAdmins.splice(0, 0, this.authService.loginUser);
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.formData.invalid) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FORM_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.FORM_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });

      return;
    }
    this.loading = true;
    const data = this.formData.value;
    if (this.factory && this.factory.id) {
      this.factoryService.updateRecord(data, this.factory.id).subscribe(
        (resp :any) => {
          this.toastr.success(
            this.translate.instant('MESSAGES.UPDATE_SUCCESS.TEXT'),
            this.translate.instant('MESSAGES.UPDATE_SUCCESS.TITLE'),
          );
          this.activeModal.close(resp.record);
        },
        (errorResp) => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
            text: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TEXT'),
            type: 'error',
            confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
          });
        },
      );
    } else {
      this.factoryService.createRecord(data).subscribe(
        (resp :any) => {
          this.toastr.success(resp.message, 'Save Successful!');
          this.activeModal.close(resp.record);
        },
        (errorResp) => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
            text: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TEXT'),
            type: 'error',
            confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
          });
        },
      );
    }
  }
}
